<template>
  <el-card shadow="never" class="aui-card--fill">
    <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
      >
        <el-form-item>
          <el-select v-model="dataForm.userId" filterable clearable placeholder="资金方">
            <el-option v-for="item in  fundList" :key="item.userId" :value="item.userId" :label="item.deptName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.typeId" filterable clearable placeholder="类型">
            <el-option v-for="item in  typeList" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.childrenId" filterable clearable placeholder="子类型">
            <el-option v-for="item in  typeChildrenList" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.productId" filterable clearable placeholder="借款产品">
            <el-option v-for="item in  borrowType" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.feeType" filterable clearable placeholder="收费方式">
            <el-option v-for="item in  chargeWayList" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item>
            <el-date-picker
                    v-model="date"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="充值开始日期"
                    end-placeholder="充值结束日期"
                     :default-time="['00:00:00','23:59:59']"
                     value-format="yyyy-MM-dd HH:mm:ss"
                    @change="getTimes"
                    unlink-panels>
            </el-date-picker>
        </el-form-item> -->
        
        
        <el-form-item>
          <div class="btn">
            <el-button @click="getDataList('dept')">{{ $t("query") }}</el-button>
            <el-button type="primary" @click="addOrUpdateHandle()" v-if="$hasPermission('system:serviceFees:save')">
              <div class="add_records">
                <img src="../../../assets/img/add.svg" alt="">
                <span>记录</span>
              </div>
            </el-button>
          </div>
        </el-form-item>
      </el-form>
    <el-table
        v-loading="dataListLoading"
        :data="dataList"
        style="width: 100%"
        border
    >
      <el-table-column prop="userName" label="资金方" header-align="center" align="center"></el-table-column>
      <el-table-column prop="price" label="类型" header-align="center" align="center" width="120px">
        <template slot-scope="scope">
          <div class="td_item" :style="item == scope.row.list[0] ? 'border-top:none': 'border-top: 1px solid #EBEEF5;'" v-for="(item,index) in scope.row.list" :key="index">{{item.typeName}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="子类型" header-align="center" align="center" width="120px">
        <template slot-scope="scope">
          <div class="td_item" :style="item == scope.row.list[0] ? 'border-top:none': 'border-top: 1px solid #EBEEF5;'" v-for="(item,index) in scope.row.list" :key="index">
            <span v-if="item.childrenName">{{item.childrenName}}</span>
            <span v-else><br></span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="借款产品" header-align="center" align="center" width="100px">
        <template slot-scope="scope">
          <div class="td_item" :style="item == scope.row.list[0] ? 'border-top:none': 'border-top: 1px solid #EBEEF5;'" v-for="(item,index) in scope.row.list" :key="index">
            <span v-if="item.productName">{{item.productName}}</span>
            <span v-else><br></span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="收费方式" header-align="center" align="center" width="120px">
        <template slot-scope="scope">
          <div class="td_item" :style="item == scope.row.list[0] ? 'border-top:none': 'border-top: 1px solid #EBEEF5;'" v-for="(item,index) in scope.row.list" :key="index">
            <span v-if="item.feeType">{{item.feeType}}</span>
            <span v-else><br></span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="条件" header-align="center" align="center" width="200px">
        <template slot-scope="scope">
          <div class="td_item" :style="item == scope.row.list[0] ? 'border-top:none': 'border-top: 1px solid #EBEEF5;'" v-for="(item,index) in scope.row.list" :key="index">
            <span v-if=" item.condition">{{ (item.payChannelId == 1 && item.childrenName == '充值') ? `${item.condition}, 上限${item.amountUpperLimit}, 下限${ item.amountLowerLimit}` :  item.condition}}</span>
            <span v-else><br></span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="费率/费用" header-align="center" align="center" width="160px">
        <template slot-scope="scope">
          <div class="td_item" :style="item == scope.row.list[0] ? 'border-top:none': 'border-top: 1px solid #EBEEF5;'" v-for="(item,index) in scope.row.list" :key="index">
            <span v-if="item.feeAmount">{{(item.typeName == '通道费' || (item.payChannelId == 1 && item.childrenName == '充值')) ? item.feeAmount + '%' : '￥'+Number(item.feeAmount).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })}}</span>
            <span v-else><br></span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="payChannelId" label="三方支付" header-align="center" align="center">
        <template slot-scope="scope">
          <div class="td_item" :style="item == scope.row.list[0] ? 'border-top:none': 'border-top: 1px solid #EBEEF5;'" v-for="(item,index) in scope.row.list" :key="index">
            <span v-if="item.payChannelId != null">
              <span v-if="item.payChannelId == 0"> 连连支付 </span>
              <span v-else-if="item.payChannelId == 1"> 统统付 </span>
            </span>
            <span v-else><br></span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="生效日期" header-align="center" align="center" width="100px">
        <template slot-scope="scope">
          <div>{{ scope.row.list[0].effectiveDate }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="录入员" header-align="center" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.list[0].inputter }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="录入时间" header-align="center" align="center" width="100px">
        <template slot-scope="scope">
          <div>{{ scope.row.list[0].inputTime }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="复核员" header-align="center" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.list[0].reviewer }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="复核时间" header-align="center" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.list[0].reviewTime }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" header-align="center" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.list[0].status == 'AWAIT_RE_CHECK'">待复核</div>
          <div v-else-if="scope.row.list[0].status == 'RE_CHECK_REFUSE'">复核拒绝</div>
          <div v-else-if="scope.row.list[0].status == 'TAKE_EFFECT'">生效</div>
        </template>
      </el-table-column>
      <el-table-column prop="operate" label="操作" header-align="center" align="center" width="160px">
        <template slot-scope="scope">
          <el-button v-if="scope.row.list[0].status == 'AWAIT_RE_CHECK' && $hasPermission('system:serviceFees:review')" class="ope_btn" type="primary" plain size="small" @click="addOrUpdateHandle(scope.row.batchId,'review')">复核</el-button>
          <el-button v-if="scope.row.list[0].status == 'RE_CHECK_REFUSE' && $hasPermission('system:serviceFees:update')" class="ope_btn" type="primary" plain size="small"  @click="addOrUpdateHandle(scope.row.batchId,'update')">修改</el-button>
        </template>
      </el-table-column>
      
    </el-table>
    <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="parseInt(total)"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
    </el-pagination>
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update
        v-if="addOrUpdateVisible"
        ref="addOrUpdate"
        @refreshDataList="getDataList"
      ></add-or-update>
  </el-card>
</template>
<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './collect-add-or-update.vue'
export default {
  mixins: [mixinViewModule],
  components:{
    AddOrUpdate
  },
  // filters: {
  //   formatDate(value) {
  //     if (!value) return '';
  //     const date = new Date(value);
  //     const year = date.getFullYear();
  //     const month = (date.getMonth() + 1).toString().padStart(2, '0');
  //     const day = date.getDate().toString().padStart(2, '0');
  //     return `${year}-${month}-${day}`;
  //   }
  // },
  data() {
    return {
      date:null,
      fundList:[],
      borrowType:[],
      chargeWayList:[],
      typeList:[],
      typeChildrenList:[],
      // dataList:[
      //   {funing:'资金方11111111111111111111',price:'500',status:1},
      //   {funing:'资金方2',price:'50',status:1},  
      // ],
      mixinViewModuleOptions: {
        getDataListURL: `/system/serviceFees/pageList`,
        getDataListIsPage: true,
        multilist:true,

      },
      limit:50
    } 
  },
  created(){
    this.init()
  },
  methods:{
    init(){
      this.$http.get('/sys/user/queryUserIdList').then(res=>{
        this.fundList = res.data.data
      })
      this.$http.get('/loan/tproduct/page',{
        page: 1,
        limit: 1000,
      }).then(r => {
        this.borrowType = r.data.data.list.map(item => ({value:item.productCode,label:item.productName     
        }))
      })
      this.$http.get(`/sys/dict/data/list?dataType=charge_way`).then(r=>{
        this.chargeWayList = r.data.data ? r.data.data.map(item => ({value:item.dictLabel,label:item.dictLabel})) : []
      })
      this.$http.get('/system/serviceFeesType/list/1').then(res=>{
        this.typeList = res.data.data
      })
      this.$http.get(`/system/serviceFeesType/list/0`).then(res=>{
        this.typeChildrenList = res.data.data
      })
    },
    getTimes() {
        if (this.date != null) {
          this.dataForm.startTime = this.date[0]
          this.dataForm.endTime = this.date[1]
          console.log(33,this.dataForm);
        }else{
          this.dataForm.startTime =''
          this.dataForm.endTime = ''
        }
    },
  }
}
</script>
<style scoped lang="scss">
::v-deep .el-table td{
  padding: 0;
}
::v-deep .el-table td:nth-child(2) .cell,
::v-deep .el-table td:nth-child(3) .cell,
::v-deep .el-table td:nth-child(4) .cell,
::v-deep .el-table td:nth-child(5) .cell,
::v-deep .el-table td:nth-child(6) .cell,
::v-deep .el-table td:nth-child(7) .cell,
::v-deep .el-table td:nth-child(8) .cell,
::v-deep .el-table td:nth-child(15) .cell{
  padding: 0;
}
.td_item{
  padding: 5px 0;
}
.btn{
  display: flex;
  align-items: center;
}
  .add_records{
    display: flex;
    align-items: center;
    img{
      width: 12px;
      margin-right: 4px;
    }
  }
  .ope_btn{
    padding: 5px 10px;
  }
</style>